export let API_URL: string;
export let Redirect_URI: string;

const node_env = process.env.NODE_ENV;

if (node_env === "development") {
    console.log("Starting on dev")
    API_URL = "http://localhost:8080";
    Redirect_URI = "https://localhost:3000";
} else if (node_env === "production") {
    console.log("Starting on prod")
    API_URL = "https://mitarbeiterportal-backend-abc8bubxdpddg3du.westeurope-01.azurewebsites.net";
    Redirect_URI = "https://umweltportal.btb.gmbh";
}
